import axios from 'axios';
import config from '../config';

const API_URL = config.API_URL;

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add interceptor to include the auth token in requests (if available)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const surveyService = {
  // Submit survey response
  submitSurveyResponse: async (surveyData) => {
    try {
      const response = await api.post('/survey/submit', surveyData);
      return response.data;
    } catch (error) {
      console.error('Error submitting survey response:', error);
      throw error;
    }
  }
};

export default surveyService;
